export interface AuditMatchCounts {
  expected_rows: number;
  matched: number;
}

/** One-line reconcile summary for run list rows (avoids ambiguous "0/0 matched"). */
export function formatAuditMatchSummary(run: AuditMatchCounts): string {
  const { expected_rows, matched } = run;
  if (expected_rows === 0) {
    return "No rep activity to compare";
  }
  if (matched === expected_rows) {
    return `All ${expected_rows} rows matched`;
  }
  return `${matched}/${expected_rows} rows matched`;
}
